import { Color, LinearSRGBColorSpace, Mesh, RepeatWrapping, ShaderMaterial, TextureLoader, Vector2 } from 'three';
import vertex from './vertex.glsl';
import fragment from './fragmnet.glsl';
import * as dat from 'dat.gui';
import { Cloudflare } from '../../../api/Cloudflare';
import {assignDeep, resourcesFolder, threeJsVariables} from '../../../../settings';

const DEFAULT_SETTINGS = {
    scale: 1,
    speed: 0.01,
    flowX: -0.138,
    flowY: 1,
    distortionStrength: 0.12,
    noise: `${config.cdnRepository}/DreamsGeneralStorage/textures/water/noise.jpg`,
    water: `${config.cdnRepository}/DreamsGeneralStorage/textures/water/water.jpg`
};

export class OrbitSea extends Mesh{
    constructor (geometry,options = {}) {
        super(geometry);
        this.params = assignDeep(DEFAULT_SETTINGS,config.features.dayNight.settings.sea);
        const loader = options.loader || new TextureLoader();
        const noiseUrl = this.params.noise.match(/http/g) ? this.params.noise :
            `${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/points/${this.params.noise}`;
        const waterUrl = this.params.water.match(/http/g) ? this.params.water :
            `${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/points/${this.params.water}`;

        const noise = loader.load(noiseUrl,loadedTexture => threeJsVariables.renderer.initTexture(loadedTexture));
        const water = loader.load(waterUrl,loadedTexture => threeJsVariables.renderer.initTexture(loadedTexture));
        noise.wrapS = noise.wrapT = RepeatWrapping;
        water.wrapS = water.wrapT = RepeatWrapping;

        this.material  = new ShaderMaterial({
            vertexShader: vertex,
            fragmentShader: fragment,
            uniforms: {
                uTime: { value: 0 },
                uWaterScale: { value: this.params.scale },
                uDistortionStrength: { value: this.params.distortionStrength },
                uWaterSpeed: { value: this.params.speed },
                uFlow: {value: new Vector2(this.params.flowX,this.params.flowY)},
                wave: {value: noise},
                water: {value: water},
                uSeaColor: { value: new Color().setStyle('#ffffff',LinearSRGBColorSpace)},
                uWaveColor: { value: new Color().setStyle('#ffffff',LinearSRGBColorSpace)}
            }
        });

        if (this.params.debug) {
            this.debug();
        }
    }

    debug() {
        const gui = new dat.GUI();
        gui.add(this.params,'scale',0, 5, 0.001).onChange(v => {
            this.material.uniforms.uWaterScale.value = v;
        });
        gui.add(this.params,'flowX',-5, 5, 0.001).onChange(v => {
            this.material.uniforms.uFlow.value.x = v;
        });
        gui.add(this.params,'flowY',-5, 5, 0.001).onChange(v => {
            this.material.uniforms.uFlow.value.y = v;
        });

        gui.add(this.params,'speed',0, 0.1, 0.0001).onChange(v => {
            this.material.uniforms.uWaterSpeed.value = v;
        });

        gui.add(this.params,'distortionStrength',-1, 1, 0.001).onChange(v => {
            this.material.uniforms.uDistortionStrength.value = v;
        });
    }

}

